export const onboardingRouter = [
  {
    path: "/staff-manage/onboarding/list",
    name: "onboarding-list",
    meta: { title: "入职管理" },
    component: () =>
      import(
        /* webpackChunkName: "onboarding-list" */ "@/views/staff-manage/onboarding/list/index.vue"
      ),
  },
  {
    path: "/staff-manage/onboarding/edit/:id",
    name: "onboarding-edit",
    meta: { title: "编辑入职登记"  , comName:"StaffManageOnboardingFormCreate" },
    hidden: true,
    component: () =>
      import(
        /* webpackChunkName: "onboarding-edit" */ "@/views/staff-manage/onboarding/form-create/index.vue"
      ),
  },
  {
    path: "/staff-manage/onboarding/add",
    name: "onboarding-add",
    hidden: true,
    meta: { title: "新增入职管理" , comName:"StaffManageOnboardingFormCreate"},
    component: () =>
      import(
        /* webpackChunkName: "onboarding-add" */ "@/views/staff-manage/onboarding/form-create/index.vue"
      ),
  },
  {
    path: "/staff-manage/onboarding/detail/:id",
    name: "onboarding-detail",
    meta: { title: "入职登记详情 " },
    hidden: true,
    component: () =>
      import(
        /* webpackChunkName: "onboarding-add" */ "@/views/staff-manage/onboarding/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/staff-manage/onboarding/flowPrint/:id",
    name: "onboarding-flow-print",
    meta: { title: "流程打印" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/staff-manage/onboarding/flow-print/index.vue"
      ),
  },
];
